export default __webpack_public_path__ + "static/vivax2-ab742c21189fbea8fa30bada72d49d8f.jpg";